import React, { useState } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { useSelector } from "react-redux";

import TEMSeminar from "./TEMSeminar";
import TTESeminar from "./TTESeminar";

function Technical() {
  const isMobile = useSelector((state) => state.windowSize.isMobile);
  const [active, setActive] = useState("TEM"); // default left

  const contentAlign = isMobile ? "center" : "left";

  return (
    <Box
      // 0 margin on mobile, 15% on desktop
      mx={isMobile ? 0 : "10%"}
      py={8}
    >
      {/* -------- Segmented Toggle -------- */}
      <Flex
        w="100%"
        mb={8}
        border="1px solid"
        borderColor="gray.300"
        borderRadius="full"
        overflow="hidden"
      >
        <Flex
          flex="1"
          justify="center"
          align="center"
          textAlign="center"
          py={4}
          cursor="pointer"
          fontWeight="600"
          bg={active === "TEM" ? "gray.200" : "white"}
          transition="0.2s"
          onClick={() => setActive("TEM")}
        >
          TECHNICAL - ETHICAL MENTORSHIP SEMINAR SERIES
        </Flex>

        <Flex
          flex="1"
          justify="center"
          align="center"
          textAlign="center"
          py={4}
          cursor="pointer"
          fontWeight="600"
          bg={active === "TTE" ? "gray.200" : "white"}
          transition="0.2s"
          onClick={() => setActive("TTE")}
        >
          TECHNOLOGY TRANSFER ENTREPRENEURSHIP
        </Flex>
      </Flex>

      {/* -------- Content -------- */}
      {active === "TEM" ? (
        <>
          <Text
            fontSize="2xl"
            fontWeight="bold"
            textAlign="center"
            mb={4}
          >
            TECHNICAL - ETHICAL MENTORSHIP SEMINAR SERIES
          </Text>

          <Text textAlign={contentAlign} mb={6}>
            <b>The Technical-Ethical Mentorship Seminar Series</b>, abbreviated as TEM, is an integral component of the TRAVERSAL program. 
            This series provides trainees with valuable insights into the latest technical advancements in the field of autonomous vehicles 
            (AVs) and uncrewed aerial vehicles (UAVs). Additionally, TEM addresses the legal and ethical dimensions associated with AV and 
            UAV-based services. It consists of a minimum of eight seminars per year, ensuring that trainees receive comprehensive knowledge 
            and guidance in both technical and ethical aspects of their field. Through TEM, trainees gain a well-rounded understanding of 
            the complex and evolving landscape of AV and UAV technologies.
          </Text>

          <TEMSeminar />
        </>
      ) : (
        <>
          <Text
            fontSize="2xl"
            fontWeight="bold"
            textAlign="center"
            mb={4}
          >
            TECHNOLOGY TRANSFER ENTREPRENEURSHIP
          </Text>

          <Text textAlign={contentAlign} mb={6}>
            <b>The Technology Transfer Entrepreneurship</b> aspect of the TRAVERSAL program focuses on equipping trainees with the knowledge and skills 
            required for successful technology readiness and commercialization. This segment provides strategies for taking research outcomes 
            from the program and translating them into viable commercial products or services. Trainees receive seminar support through technology 
            transfer offices and benefit from the expertise of alumni from startup accelerators. To ensure comprehensive training, trainees are 
            required to attend a minimum of four seminars in each stream per year. This emphasis on technology transfer and entrepreneurship 
            empowers trainees to effectively navigate the journey from research to real-world applications, fostering innovation and economic 
            impact.
          </Text>

          <TTESeminar />
        </>
      )}
    </Box>
  );
}

export default Technical;
